import { validateCaseListSearch } from '@/features/air/case-management/lib/strict-case-list-search'

/**
 * The multi-tenant Cases tab's `validateSearch`: the strict Case list URL of
 * `/air/case-management`, invalid values removed and named in a toast.
 *
 * It lives here so the route imports one feature only (A-01). The alias is the
 * contract: both Case lists must accept the same URL.
 */
export const validateMultiTenantCasesSearch = validateCaseListSearch
